<wl-experience-editor>
  <ng-template wlLive>
    <ngb-alert
      class="d-flex align-items-start border-0 p-2"
      type="danger"
      [dismissible]="false"
      [wlTrackError]="{
        rendering: rendering,
        field: message,
        description: messageDescription,
        type: 'system error',
      }"
    >
      <fa-icon
        class="icon icon--danger me-2 text-danger fa-lg"
        icon="triangle-exclamation"
        [wlAutomationId]="automationId"
      ></fa-icon>
      <span class="text-gray-900" *scText="message"></span>
    </ngb-alert>
  </ng-template>
  <ng-template wlPreview>
    <ngb-alert
      class="d-flex align-items-start border-0 p-2"
      type="danger"
      [dismissible]="false"
    >
      <fa-icon
        class="icon icon--danger me-2 text-danger fa-lg"
        icon="triangle-exclamation"
      ></fa-icon>
      <span class="text-gray-900" *scText="message"></span>
    </ngb-alert>
  </ng-template>
</wl-experience-editor>
